module.exports = __webpack_public_path__ + "img/Logo-Bloom-Vorschaubild.5e63d09f.png";